exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "mw-chart-two-y-axis-line {\n    display: block;\n    height: 100%;\n}", ""]);
